import { Environment, ENVIRONMENT_URLS } from '@common/constants/environment'

export function redirectToEnvironment(env: Environment): void {
  const targetUrl = ENVIRONMENT_URLS[env]

  if (targetUrl && targetUrl !== window.location.origin) {
    window.location.href = targetUrl
  }
}
